import Flex from '@Components/Bases/Flex';
import { FormInput } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';
import { Box, InputLabel } from '@mui/material';

type ImageFieldsProps = {
  name?: string;
  index: number;
  local?: 'Th' | 'En';
  disabledTh?: boolean;
  disabledEn?: boolean;
};

const ImageFields: React.FC<ImageFieldsProps> = ({
  name,
  index,
  local = 'Th',
  disabledTh = false,
  disabledEn = false,
}) => {
  const lowerLocal = local?.toLowerCase();

  return (
    <>
      <Flex width={1} justifyContent={'center'} mt={2}>
        <Box
          id={`${name}-${lowerLocal}-image-${index}`}
          component={'img'}
          maxWidth={650}
        />
      </Flex>
    </>
  );
};

export default ImageFields;
